/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const GET_ALL_COMMENT_LIST_COMM = 'GET_ALL_COMMENT_LIST_COMM';
export const SAVE_OR_UPDATE = 'SAVE_OR_UPDATE';
export const DELETE_COMMENT = 'DELETE_COMMENT';
export const GET_GENERAL_SYSTEM_PARAMETER_COMM =
  'GET_GENERAL_SYSTEM_PARAMETER_COMM';
export const COMMENT_TAB_DATA = 'COMMENT_TAB_DATA';
export const FETCH_GENERATE_SEQ_NUM = 'FETCH_GENERATE_SEQ_NUM';

// common poc comment & correspondence
export const CREATE_NEW_SEQ_NUM = 'CREATE_NEW_SEQ_NUM';
export const GET_COMMENT_LIST_FOR_COMMON_POC =
  'GET_COMMENT_LIST_FOR_COMMON_POC';
export const GET_LINK_TABLE_DATA = 'GET_LINK_TABLE_DATA';
export const SAVE_OR_UPDATE_FOR_COMMON_POC = 'SAVE_OR_UPDATE_FOR_COMMON_POC';
export const DELETE_COMMENT_FOR_COMMON_POC = 'DELETE_COMMENT_FOR_COMMON_POC';
export const COMMENT_DATA = 'COMMENT_DATA';
export const DISABLE_UPDATE = 'DISABLE_UPDATE'